(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-hover-popover"] && !Shopify.designMode) return;
  try {
    (() => {
  const trigger = document.querySelector('.header__icon--account');
  const panel = document.getElementById('AccountHoverPopover');
  if (!trigger || !panel) return;
  let hideTimer;

  const positionPanel = () => {
    const rect = trigger.getBoundingClientRect();
    panel.style.right = `calc(100vw - ${rect.right}px)`;
    panel.style.top = `${rect.bottom + 6}px`;
  };

  const showPanel = () => {
    clearTimeout(hideTimer);
    positionPanel();
    panel.classList.add('is-visible');
  };

  const hidePanel = () => {
    hideTimer = setTimeout(() => {
      panel.classList.remove('is-visible');
    }, 120);
  };

  trigger.addEventListener('mouseenter', showPanel);
  trigger.addEventListener('mouseleave', hidePanel);
  panel.addEventListener('mouseenter', () => clearTimeout(hideTimer));
  panel.addEventListener('mouseleave', hidePanel);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-hover-popover"] && !Shopify.designMode) return;
  try {
    (() => {
  const trigger = document.querySelector('#cart-icon-bubble');
  const panel = document.getElementById('CartHoverPopover');
  if (!trigger || !panel) return;
  let hideTimer;

  const positionPanel = () => {
    const rect = trigger.getBoundingClientRect();
    panel.style.right = `calc(100vw - ${rect.right}px)`;
    panel.style.top = `${rect.bottom + 6}px`;
  };

  const showPanel = () => {
    clearTimeout(hideTimer);
    positionPanel();
    panel.classList.add('is-visible');
  };

  const hidePanel = () => {
    hideTimer = setTimeout(() => {
      panel.classList.remove('is-visible');
    }, 120);
  };

  trigger.addEventListener('mouseenter', showPanel);
  trigger.addEventListener('mouseleave', hidePanel);
  panel.addEventListener('mouseenter', () => clearTimeout(hideTimer));
  panel.addEventListener('mouseleave', hidePanel);

  // "Checkout" (#CartHoverOpenDrawer) is handled centrally in cart-drawer.liquid:
  //  - non-wholesale visitors get the sign-up gate modal;
  //  - approved wholesale customers are routed through the cart page so the
  //    Wholesale Pricing Discount app applies the discount, then auto-continued
  //    to checkout.
  // No per-button handler is needed here.
})();
  } catch(e) { console.error(e); }
})();

})();
